module.exports = __webpack_public_path__ + "static/img/genre_04.c9fc9e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/genre_04.png
// module id = Sn58
// module chunks = 0